import styled from "styled-components";
export const Section = styled.div`
  margin: 1rem 0 2rem;
`;
